<template>
  <div id="help-whatsapp-protocol">
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mb-8">
        <span>{{currentPage}}/{{pageCount}}</span>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button 
          radius 
          color="primary" 
          type="flat"
          icon="chevron_left"
          @click="previousPdfPage"
          :disabled="currentPage === 1"
        />
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <vx-card>
          <pdf
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
            :src="currentPdf"
          />
        </vx-card>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button 
          radius 
          color="primary"
          type="flat"
          icon="chevron_right"
          @click="nextPdfPage"
          :disabled="currentPage === pageCount"
        />
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-8">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
          <vs-pagination 
            :total="pageCount" 
            v-model="currentPage" 
            prev-icon="arrow_back" 
            next-icon="arrow_forward"
          />
        </vs-col>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'

  export default {
    name: 'help-whatsapp-protocol',
    data() {
      return {
        isMounted: false,
        currentPdf: 'https://clean-code.s3.amazonaws.com/pedbot/pdfs/1599418746yY2SZJxzrN.pdf',
        currentPage: 1,
        pageCount: 1,
      }
    },
    methods: {
      previousPdfPage() {
        if (this.currentPage > 1) {
          this.currentPage--
        }
      },
      nextPdfPage() {
        if (this.currentPage < this.pageCount) {
          this.currentPage++
        }
      }
    },
    mounted() {
      this.isMounted = true
    },
    components: {
      pdf
    }
  }
</script>